import React, { useEffect, useState } from "react";
import { Card, Badge } from "react-bootstrap";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Table } from "react-bootstrap";
import parse from "html-react-parser";
import { CustomOutlinedDisabledTextField } from "../../../../../../partials/content/Forms";
import { formatDate } from "../../../../../../utils/utils";
import { Editor } from "primereact/editor";
import { Timeline } from "primereact/timeline";
import { Step, StepLabel, Stepper, Typography } from "@material-ui/core";
import BootstrapTooltip from "../../../../../../partials/content/BootstrapTooltip";
import Illustration from "../../../../../../partials/content/Illustration";
import { getRfqDetail } from "../../../../../../services/inventory/procurementService";

function RfqBasicInfo({
  rfqID = 0,
  rfqDataImp = {
    ID: 0,
    rfqCode: "",
    biddingTypeName: "",
    purchaseOrderCode: "",
    currency: { currencyCode: "" },
    warehouse: { warehouseName: "" },
    classification: { classificationName: "" },
    rfqItems: [],
    approvalStatusDesc: "",
    note: "",
    toc: "",
  },
  approvalProcessImp = [],
  approvalStepsImp = [],
  approvalActiveStepImp = 0,
  approvalAction = false,
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeIndex2, setActiveIndex2] = useState(0);
  const [rfq, setRfq] = useState(rfqDataImp);
  const [rfqVendors, setRfqVendors] = useState([]);
  const [approvalProcess, setApprovalProcess] = useState(approvalProcessImp);
  const [approvalSteps, setApprovalSteps] = useState(approvalStepsImp);
  const [approvalActiveStep, setApprovalActiveStep] = useState(
    approvalActiveStepImp
  );
  useEffect(() => {
    if (rfqID > 0) {
      getRfqDetailData(rfqID);
    }
  }, [rfqID]);
  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel
              header="Request For Quotation Main"
              rightIcon="fas fa-th-large"
            >
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Request For Quotation Header</strong>
                      </span>
                      {rfq.purchaseOrderID > 0 ? (
                        <Badge className="float-right ml-1" variant="primary">
                          {`Purchase Order ID ${rfq.purchaseOrderCode}`}
                        </Badge>
                      ) : null}
                      <Badge
                        className="float-right ml-1"
                        variant={
                          rfq.statusID === 1
                            ? "success"
                            : rfq.statusID === 3
                            ? "danger"
                            : null
                        }
                      >
                        {rfq.statusID !== 0
                          ? "Bidding " + rfq.statusName
                          : null}
                      </Badge>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Request For Quotation ID"
                            value={rfq.rfqCode}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Bidding Type"
                            value={rfq.biddingTypeName}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Destination Warehouse Name"
                            value={rfq.warehouse.warehouseName}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Currency"
                            value={rfq.currency.currencyCode}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Quotation Request Date"
                                value={formatDate(rfq.rfqDate)}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Response Deadline Date"
                                value={formatDate(rfq.deadlineDate)}
                              />
                            </div>
                          </div>
                          <CustomOutlinedDisabledTextField
                            label="Expected Delivery Date"
                            value={formatDate(rfq.expDeliveryDate)}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Classification"
                            value={rfq.classification.classificationName}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Approval Status"
                            value={rfq.approvalStatusDesc}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="accordion">
                <div className="card">
                  <Accordion
                    className="accordion"
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                  >
                    <AccordionTab
                      header={
                        <React.Fragment>
                          <i className="fas fa-sitemap"></i>
                          <span>
                            <strong>Request For Quotation Items</strong>
                          </span>
                        </React.Fragment>
                      }
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="card">
                            <Table striped borderless size="sm" responsive="xl">
                              {rfq.rfqItems && rfq.rfqItems.length > 0 ? (
                                <thead>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      <Typography className="mx-1 kt-font-bolder">
                                        Item Name
                                      </Typography>
                                    </th>
                                    <th style={{ width: "25%" }}>
                                      <Typography className="mx-1 kt-font-bolder">
                                        Quantity
                                      </Typography>
                                    </th>
                                    <th style={{ width: "25%" }}>
                                      <Typography className="mx-1 kt-font-bolder">
                                        Unit
                                      </Typography>
                                    </th>
                                  </tr>
                                </thead>
                              ) : null}
                              <tbody>
                                {rfq.rfqItems && rfq.rfqItems.length > 0 ? (
                                  rfq.rfqItems.map((item, index) => (
                                    <tr key={index} className="border-top">
                                      <td>
                                        <Typography className="mx-1 my-1">
                                          {item.itemType > 0 ? (
                                            <span>
                                              <BootstrapTooltip
                                                title={item.itemTypeName}
                                              >
                                                <span className="mr-2">
                                                  <i
                                                    className={
                                                      item.itemType === 1
                                                        ? "fas fa-boxes text-success"
                                                        : item.itemType === 2
                                                        ? "fas fa-tools text-primary"
                                                        : item.itemType === 3
                                                        ? "fas fa-building text-info"
                                                        : item.itemType === 4
                                                        ? "fas fa-boxes text-warning"
                                                        : item.itemType === 5
                                                        ? "fas fa-boxes text-danger"
                                                        : null
                                                    }
                                                  ></i>
                                                </span>
                                              </BootstrapTooltip>
                                              <span>
                                                {item.itemCode} {item.itemName}
                                              </span>
                                            </span>
                                          ) : (
                                            <React.Fragment>
                                              {item.itemCode} {item.itemName}
                                            </React.Fragment>
                                          )}
                                        </Typography>
                                      </td>
                                      <td>
                                        <Typography className="mx-1 my-1">
                                          {item.qty}
                                        </Typography>
                                      </td>
                                      <td>
                                        <Typography className="mx-1 my-1">
                                          {item.itemUom.uomName}
                                        </Typography>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      className="text-center py-3"
                                      colSpan="3"
                                    >
                                      <Illustration
                                        imageSource="INVIFO Procurement.png"
                                        guidance="You don't have any Request For Quotation items yet"
                                        guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                        size="sm"
                                      ></Illustration>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>
              </div>
              {approvalAction ? (
                <div className="accordion mt-3">
                  <div className="card">
                    <Accordion
                      className="accordion"
                      activeIndex={activeIndex2}
                      onTabChange={(e) => setActiveIndex2(e.index)}
                    >
                      <AccordionTab
                        header={
                          <React.Fragment>
                            <i className="fas fa-handshake"></i>
                            <span>
                              <strong>Vendors</strong>
                            </span>
                          </React.Fragment>
                        }
                      >
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="card">
                              <Table
                                striped
                                borderless
                                size="sm"
                                responsive="xl"
                              >
                                {rfqVendors && rfqVendors.length > 0 ? (
                                  <thead>
                                    <tr>
                                      <th style={{ width: "10%" }}>
                                        <Typography className="mx-1 kt-font-bolder">
                                          Vendor ID
                                        </Typography>
                                      </th>
                                      <th style={{ width: "75%" }}>
                                        <Typography className="mx-1 kt-font-bolder">
                                          Vendor Name
                                        </Typography>
                                      </th>
                                      <th style={{ width: "15%" }}>
                                        <Typography className="mx-1 kt-font-bolder">
                                          Quotation Status
                                        </Typography>
                                      </th>
                                    </tr>
                                  </thead>
                                ) : null}
                                <tbody>
                                  {rfqVendors && rfqVendors.length > 0 ? (
                                    rfqVendors.map((item, index) => (
                                      <tr key={index} className="border-top">
                                        <td>
                                          <Typography className="mx-1 my-1">
                                            {item.vendorID}
                                          </Typography>
                                        </td>
                                        <td>
                                          <Typography className="mx-1 my-1">
                                            {item.vendorName}
                                          </Typography>
                                        </td>
                                        <td>
                                          <Typography>
                                            <Badge
                                              className="mx-1 my-1"
                                              variant={
                                                item.statusID === 1
                                                  ? "warning"
                                                  : item.statusID === 2
                                                  ? "primary"
                                                  : item.statusID === 3
                                                  ? "danger"
                                                  : item.statusID === 4
                                                  ? "success"
                                                  : null
                                              }
                                            >
                                              {item.statusID !== 0
                                                ? item.statusName
                                                : null}
                                            </Badge>
                                          </Typography>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        className="text-center py-3"
                                        colSpan="3"
                                      >
                                        <Illustration
                                          imageSource="INVIFO Procurement.png"
                                          guidance="You don't have any Vendors for this request for quotation yet"
                                          guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                          size="sm"
                                        ></Illustration>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        </div>
                      </AccordionTab>
                    </Accordion>
                  </div>
                </div>
              ) : null}
            </TabPanel>
            <TabPanel
              header={`Note, Terms & Conditions`}
              rightIcon="fas fa-sticky-note"
            >
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Note</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        value={rfq.note}
                        placeholder="Type your notes here..."
                        readOnly={true}
                        className="editor-grey"
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Terms & Conditions</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        value={rfq.toc}
                        placeholder="Type your terms & conditions here..."
                        readOnly={true}
                        className="editor-grey"
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            {approvalProcess.length ? (
              <TabPanel
                header="Approval Flow"
                rightIcon="fas fa-file-signature"
              >
                {approvalSteps.length ? (
                  <Stepper activeStep={approvalActiveStep} alternativeLabel>
                    <Step>
                      <StepLabel
                        optional={
                          <Typography align="center" variant="body2">
                            INITIATED
                          </Typography>
                        }
                      >
                        Document Approval
                      </StepLabel>
                    </Step>
                    {approvalSteps.map((label, index) => {
                      const stepProps = {};
                      const labelProps = {};
                      if (label.level < rfq.approvalProcess.level)
                        labelProps.optional = (
                          <Typography
                            align="center"
                            variant="body2"
                            className="text-success"
                          >
                            APPROVED
                          </Typography>
                        );
                      if (
                        label.approvalID === rfq.approvalProcess.approvalID &&
                        label.level === rfq.approvalProcess.level
                      ) {
                        if (rfq.approvalProcess.statusID === 1) {
                          labelProps.error = false;
                          labelProps.optional = (
                            <Typography align="center" variant="body2">
                              IN REVIEW
                            </Typography>
                          );
                        } else if (rfq.approvalProcess.statusID === 2) {
                          labelProps.error = false;
                          stepProps.completed = true;
                          labelProps.optional = (
                            <Typography
                              align="center"
                              variant="body2"
                              className="text-success"
                            >
                              APPROVED
                            </Typography>
                          );
                        } else if (rfq.approvalProcess.statusID === 3) {
                          labelProps.error = true;
                          labelProps.optional = (
                            <Typography
                              align="center"
                              variant="body2"
                              className="text-danger"
                            >
                              REJECTED
                            </Typography>
                          );
                        }
                      }
                      return (
                        <Step key={index} {...stepProps}>
                          <StepLabel {...labelProps}>
                            {label.userGroup.groupName}
                          </StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                ) : null}
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Card>
                      <Card.Header>
                        <i className="fas fa-history"></i>
                        <span>
                          <strong>Approval Flow History</strong>
                        </span>
                      </Card.Header>
                      <Card.Body>
                        <Timeline
                          value={approvalProcess}
                          opposite={(item) => {
                            return (
                              <div>
                                {item.statusDesc}
                                {item.statusID === 2 || item.statusID === 3 ? (
                                  <React.Fragment>
                                    <br />
                                    <strong>Note :</strong>
                                    <br />
                                    {parse(item.note)}
                                  </React.Fragment>
                                ) : null}
                              </div>
                            );
                          }}
                          content={(item) => {
                            return (
                              <small className="text-muted">
                                {formatDate(item.actionDate, true)}
                              </small>
                            );
                          }}
                          marker={(item) => {
                            if (item.statusID === 0) {
                              return (
                                <span className="custom-timeline-marker bg-info">
                                  <i className="fas fa-play-circle"></i>
                                </span>
                              );
                            } else if (item.statusID === 1) {
                              return (
                                <span className="custom-timeline-marker bg-warning">
                                  <i className="fas fa-clock"></i>
                                </span>
                              );
                            } else if (item.statusID === 2) {
                              return (
                                <span className="custom-timeline-marker bg-success">
                                  <i className="fas fa-check-circle"></i>
                                </span>
                              );
                            } else if (item.statusID === 3) {
                              return (
                                <span className="custom-timeline-marker bg-danger">
                                  <i className="fas fa-times-circle"></i>
                                </span>
                              );
                            } else {
                              return (
                                <span className="custom-timeline-marker bg-dark">
                                  <i className="fas fa-question-circle"></i>
                                </span>
                              );
                            }
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </TabPanel>
            ) : (
              <TabPanel
                header="Approval Flow"
                rightIcon="fas fa-file-signature"
                disabled
              ></TabPanel>
            )}
          </TabView>
        </div>
      </div>
    </React.Fragment>
  );

  async function getRfqDetailData(rfqID = 0) {
    if (rfqID > 0) {
      const response = await getRfqDetail(rfqID);
      const { data } = response.data;
      setRfq(data.rfq);
      setRfqVendors(data.rfq.rfqVendors);
      setApprovalProcess(data.approvalProcess);
      setApprovalSteps(data.rfq.approvalProcess.approval.approvalValue);
      setApprovalActiveStep(data.rfq.approvalProcess.level);
    }
  }
}

export default RfqBasicInfo;
